import { APP_NAME, ENVIRONMENT } from "./env"

export const UNLEASH_APP_NAME =
  process.env.NEXT_PUBLIC_UNLEASH_APP_NAME || APP_NAME

export const UNLEASH_FRONTEND_API_URL = new URL(
  process.env.NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL ||
    "https://features.opensea.io/api/frontend",
)

export const UNLEASH_FRONTEND_API_TOKEN =
  process.env.NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN ||
  "*:development.c6318927a642a36da17aa86b4a6671254e01086b8e3128fc0d90eee4"

export const UNLEASH_ENVIRONMENT =
  process.env.NEXT_PUBLIC_UNLEASH_ENVIRONMENT || ENVIRONMENT
